"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.hydrate = exports.preload = exports.getExplorerConfig = void 0;
var logs_1 = require("@ledgerhq/logs");
var network_1 = __importDefault(require("../../network"));
var overrides_1 = require("./overrides");
var initialExplorerConfig = {
    bitcoin: {
        id: "btc",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    bitcoin_cash: {
        id: "bch",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    bitcoin_gold: {
        id: "btg",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    // FIXME Doesn't seem supported, should we remove?
    clubcoin: {
        id: "club",
        stable: {
            base: "EXPLORER",
            version: "v2"
        }
    },
    dash: {
        id: "dash",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    decred: {
        id: "dcr",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    digibyte: {
        id: "dgb",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    dogecoin: {
        id: "doge",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    // FIXME Doesn't seem supported, should we remove?
    hcash: {
        id: "hsr",
        stable: {
            base: "EXPLORER",
            version: "v2"
        }
    },
    komodo: {
        id: "kmd",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    litecoin: {
        id: "ltc",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    peercoin: {
        id: "ppc",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    pivx: {
        id: "pivx",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    // FIXME Doesn't seem supported, should we remove?
    poswallet: {
        id: "posw",
        stable: {
            base: "EXPLORER",
            version: "v2"
        }
    },
    qtum: {
        id: "qtum",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    stakenet: {
        id: "xsn",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    stratis: {
        id: "strat",
        stable: {
            base: "EXPLORER",
            version: "v2"
        }
    },
    stealthcoin: {
        id: "xst",
        stable: {
            base: "EXPLORER",
            version: "v2"
        }
    },
    vertcoin: {
        id: "vtc",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    viacoin: {
        id: "via",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    zcash: {
        id: "zec",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    zencash: {
        id: "zen",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    bitcoin_testnet: {
        id: "btc_testnet",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    bsc: {
        id: "bnb",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    ethereum: {
        id: "eth",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    ethereum_ropsten: {
        id: "eth_ropsten",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    ethereum_classic: {
        id: "etc",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    },
    polygon: {
        id: "matic",
        stable: {
            base: "EXPLORER",
            version: "v3"
        }
    }
};
var explorerConfig = initialExplorerConfig;
function getExplorerConfig() {
    return explorerConfig;
}
exports.getExplorerConfig = getExplorerConfig;
// these two function follows the same principle of CurrencyBridge's preload & hydrate
// and for this current PoC will be only used by the bitcoin family
// if we want in future to generalize it to all family, we would need to adapt this.
var cacheConfig = null;
var preload = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data, config;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (cacheConfig && Date.now() - cacheConfig.timestamp < 60 * 1000) {
                    return [2 /*return*/, cacheConfig.config];
                }
                return [4 /*yield*/, (0, network_1["default"])({
                        url: "https://cdn.live.ledger.com/config/explorerConfig.v1.json",
                        method: "GET"
                    })];
            case 1:
                data = (_a.sent()).data;
                try {
                    config = (0, overrides_1.asFullConfigOverrides)(data);
                    cacheConfig = {
                        timestamp: Date.now(),
                        config: config
                    };
                    return [2 /*return*/, config];
                }
                catch (e) {
                    (0, logs_1.log)("explorerConfig", "failed to load explorerConfig: " + e);
                }
                return [2 /*return*/];
        }
    });
}); };
exports.preload = preload;
var hydrate = function (maybeConfig) {
    if (!maybeConfig)
        return;
    var safe;
    try {
        safe = (0, overrides_1.asFullConfigOverrides)(maybeConfig);
    }
    catch (e) {
        (0, logs_1.log)("explorerConfig", "failed to hydrate explorerConfig: " + e);
    }
    if (!safe)
        return;
    // update explorerConfig with remote config
    explorerConfig = (0, overrides_1.applyFullConfigOverrides)(initialExplorerConfig, safe);
};
exports.hydrate = hydrate;
//# sourceMappingURL=index.js.map